import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/event-time-slots`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(`${url}/event-time-slots/${id}`, options)
    .then((response) => {
      let event = jsona.deserialize(response.data);
      delete event.links;
      return event;
    });
}

function add(event) {
  const payload = jsona.serialize({
    stuff: event,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/event-time-slots`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(event) {
  const payload = jsona.serialize({
    stuff: event,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/event-time-slots/${event.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/event-time-slots/${id}`, options);
}

function getAttendeesReport(id) {
  const options = {
    headers: {},
    responseType: "blob",
  };

  return axios.get(`${url}/event-time-slots/${id}/reports/attendees`, options);
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  getAttendeesReport,
};
